/** Спільні тексти платформи: дії, стани помилки, одиниці. Використовують кілька областей. */
export const common = {
  appName: 'Clientline',
  close: 'Закрити',
  cancel: 'Скасувати',
  save: 'Зберегти',
  undo: 'Скасувати',
  retry: 'Спробувати ще раз',
  errorText: 'Сервер не відповів. Спробуйте ще раз за хвилину.',
  /** Заголовок вкладки, коли екран не відкрився (UX-07). */
  errorTitle: 'Помилка',
  supportCode: 'Код для підтримки',
  notFoundTitle: 'Сторінку не знайдено',
  optional: '(необов’язково)',
  noTime: '—',
  of: 'з',
  minutes: 'хв',
  kilobytes: 'КБ',
} as const;
